/**
 * Dia e noite (Vitor, 15/09: "um padrao branco e outro preto para dia e noite"). Sem escolha, segue o aparelho
 * (prefers-color-scheme); o botao de sol e lua fixa claro ou escuro e o aparelho lembra (localStorage). O modo e o
 * atributo data-tema no <html>; as cores de cada modo vem do tema da marca (marcas/<marca>/tema.css).
 * O app aplica a escolha salva antes de pintar a tela (script no index.html), pra nao piscar.
 */
import { useEffect, useState } from "react";
import { IconeLua, IconeSol } from "./icones";

export type ModoDoTema = "sistema" | "claro" | "escuro";
const CHAVE = "mtc-tema";

export function temaSalvo(): ModoDoTema {
  try {
    const v = localStorage.getItem(CHAVE);
    return v === "claro" || v === "escuro" ? v : "sistema";
  } catch {
    return "sistema";
  }
}

/** Grava e aplica. "sistema" volta a seguir o aparelho. */
export function aplicarTema(modo: ModoDoTema): void {
  const raiz = document.documentElement;
  if (modo === "sistema") delete raiz.dataset.tema;
  else raiz.dataset.tema = modo;
  try {
    if (modo === "sistema") localStorage.removeItem(CHAVE);
    else localStorage.setItem(CHAVE, modo);
  } catch {
    // sem localStorage (aba anonima restrita): vale so nesta tela
  }
}

/** O modo que esta na tela agora: o escolhido ou o do aparelho. */
export function temaNaTela(): "claro" | "escuro" {
  const d = document.documentElement.dataset.tema;
  if (d === "claro" || d === "escuro") return d;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "escuro" : "claro";
}

/** Botao de sol e lua: troca entre claro e escuro. Mostra o modo pra onde vai. */
export function AlternarTema({ comRotulo = false }: { comRotulo?: boolean } = {}) {
  const [modo, setModo] = useState<"claro" | "escuro">(() => (typeof document === "undefined" ? "claro" : temaNaTela()));
  // Seguindo o aparelho, acompanha a troca dele (o celular escurece a noite).
  useEffect(() => {
    const m = window.matchMedia?.("(prefers-color-scheme: dark)");
    if (!m) return;
    const mudou = () => setModo(temaNaTela());
    m.addEventListener("change", mudou);
    return () => m.removeEventListener("change", mudou);
  }, []);
  const proximo = modo === "escuro" ? "claro" : "escuro";
  const rotulo = proximo === "claro" ? "Usar o modo claro" : "Usar o modo escuro";
  // Dentro de um menu (a conta, por exemplo) o icone sozinho nao diz nada: ali o rotulo aparece escrito.
  return (
    <button type="button" className={comRotulo ? "mtc-tema-rotulado" : "mtc-botao-icone"} aria-label={comRotulo ? undefined : rotulo} title={comRotulo ? undefined : proximo === "claro" ? "Modo claro" : "Modo escuro"} onClick={() => { aplicarTema(proximo); setModo(proximo); }}>
      {proximo === "claro" ? <IconeSol tamanho={20} /> : <IconeLua tamanho={20} />}
      {comRotulo && rotulo}
    </button>
  );
}

/** O mesmo que o script do index.html faz antes de pintar: pra quem monta a tela sem ele (Storybook, testes). */
export const SCRIPT_DO_TEMA = `try{var t=localStorage.getItem("${CHAVE}");if(t==="claro"||t==="escuro")document.documentElement.dataset.tema=t}catch(e){}`;
